import axios from "../plugins/parseAxios";

export class OrderApi {
  static getOrder(id) {
    return axios.post("functions/getOrder", { id });
  }
  static getOrderByMeter(meterId) {
    return axios.post("functions/getOrderByMeter", { meterId });
  }
  static getOrderBetweenDateByMeter(payload) {
    return axios.post("functions/getOrderBetweenDateByMeter", { 
      meterId : payload.meterId ,
      startDate : payload.startDate,
      endDate : payload.endDate
    });
  }
  static getLastOrderByMeter(meterId) {
    return axios.post("functions/getLastOrderByMeter", { meterId });
  }
  static getOrderUnPaidCoutByMeter(meterId) {
    return axios.post("functions/getOrderUnPaidCoutByMeter", { meterId });
  }
  static getLastOrderByContract(contractId) {
    return axios.post("functions/getLastOrderByContract", { contractId });
  }
  static createOrder(formData) {
    return axios.post("functions/createOrder", formData);
  }
  static cancelOrderInvoicePayment(id) {
    return axios.post("functions/cancelOrderInvoicePayment", { id });
  }
  static sendOrder(formData) {
    return axios.post("functions/sendOrder", formData);
  }
}